import { fetchCommunications, fetchCommunicators } from "./monitorFetchers";

export const FETCH_COMMUNICATORS_SUCCESS = "FETCH_COMMUNICATORS_SUCCESS";
export const FETCH_COMMUNICATIONS_SUCCESS = "FETCH_COMMUNICATIONS_SUCCESS";
export const COMMUNICATION_SELECTED = "COMMUNICATION_SELECTED";
export const PERIOD_SELECTED = "PERIOD_SELECTED";

export function fetchCommunicatorsSuccess(payload) {
    return {
        type: FETCH_COMMUNICATORS_SUCCESS,
        payload
    };
}

export function loadCommunicators() {
    return dispatch => {
        fetchCommunicators((communicators) =>
            dispatch(fetchCommunicatorsSuccess(communicators))
        )
    }
}

export function searchCommunicationsSuccess(payload) {
    return {
        type: FETCH_COMMUNICATIONS_SUCCESS,
        payload
    };
}

export function communicationSelected(payload) {
    return {
        type: COMMUNICATION_SELECTED,
        payload
    };
}

export function periodSelected(payload) {
    return {
        type: PERIOD_SELECTED,
        payload
    };
}

export function searchCommunications(communicatorId, period) {
    return dispatch => {
        fetchCommunications({ communicator: communicatorId, period }, communications => {
            dispatch(searchCommunicationsSuccess(communications));
        });
    };
}


/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/monitor/monitorActions.js
 **/